// themeNames are the looks the Console, this app and mobile share, all dark.
// vms is Ember, the default; index.html keeps its own copy of this list, as it
// runs before any module loads.
export const themeNames = ['vms', 'console', 'midnight', 'tactical', 'signal'] as const

export type ThemeName = (typeof themeNames)[number]

// themeOf is the theme to apply for what VMS reports: Ember for anything it
// does not know, such as a theme added to a newer server.
export function themeOf(name: string | undefined): ThemeName {
  return (themeNames as readonly string[]).includes(name ?? '') ? (name as ThemeName) : 'vms'
}

// applyTheme draws the page in a theme, and stores it for index.html to apply
// before the next load's first paint.
export function applyTheme(name: string | undefined): void {
  const theme = themeOf(name)
  document.documentElement.dataset.theme = theme
  try { localStorage.setItem('vms-theme', theme) } catch { /* private window: the next load flashes */ }
}
